import PageStyle from "@/styles/components/candidate-email/_index.module.scss";
import Button from "@/components/button";
import {
  InputError,
  Form,
  Formik,
  FormikControl,
  useRef,
  useRouter,
  useState,
  useEffect,
  Loading,
  Exclamation
} from "@/imports-files/common/common";
import {
  CANDIDATE_EMAIL_VALUES,
  CANDIDATE_EMAIL_VALIDATION,
  TEXTS,
} from "@/constants/components/candidate-email";
import {
  getCandidateName,
  removeAttachment,
  submitCandidateEmail,
  submitKanbanEmail,
  getPurposeOptions,
  getCustomTemplate,
  getEmailTo,
  agencyEmailTo,
} from "@/actions/components/candidate-email";
import Image from "next/image";
import { ActionShareCv } from "@/actions/components/share-cv";
import { markActiveUnsuccessful } from "@/imports-files/pages/clients/candidates/kanban";
import { ReviewEmailActions } from "@/imports-files/components/review-email";
import { FormModalStyle } from "@/imports-files/components/review-email";
import { Close } from "@/imports-files/components/common-modal/common-modal";
import cloneDeep from "lodash.clonedeep";

export function CandidateEmail(props) {
  const editorRef = useRef(null);
  const router = useRouter();
  const [attachmentList, setAttachmentList] = useState([]);
  const [initialCandidateEmailValues, setCandidateEmailInitalValues] = useState(
    CANDIDATE_EMAIL_VALUES
  );
  const [flagForRerender, setFlagForRerender] = useState(0);
  var ccValues = null;

  if (props.replySubject) {
    ccValues = cloneDeep(
      props?.data?.comm_detail?.cc ||
        props?.data?.all_data?.comm_detail?.cc ||
        props?.data?.all_data?.cc ||
        props?.ccEmails ||
        []
    );
  } else {
    ccValues = cloneDeep(
      props?.data?.comm_detail?.cc ||
        props?.data?.all_data?.comm_detail?.cc ||
        props?.data?.all_data?.cc ||
        props?.data?.cc ||
        props?.candidateCc ||
        []
    );
  }

  const [selectedValues, setSelectedValues] = useState(ccValues);
  const [selectedToValues, setSelectedToValues] = useState([]);
  const [toValue, setToValue] = useState("");
  const [value, setValue] = useState("");
  const [suggestion, setSuggestion] = useState([]);
  const formRef = useRef(null);
  const autosuggest_action = new ActionShareCv(setValue, setSuggestion);
  const [selectedUserCount, setSelectedUserCount] = useState(null);
  const [selectedToUserCount, setSelectedToUserCount] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const reviewEmailActions = new ReviewEmailActions();
  const [purposeList, setPurposeList] = useState([]);
  const [subject, setSubject] = useState(reviewEmailActions.subjectVars);
  const [dataVariables, setDataVariables] = useState(
    reviewEmailActions.bodyVars
  );
  const editorBodyRef = useRef(null);
  const editorSubjectRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSafari, setIsSafari] = useState(false);

  useEffect(async () => {
    initialCandidateEmailValues.email.reply_to =
      props.messageId || props.replyTo;
    initialCandidateEmailValues.email.subject = props.replySubject;
    initialCandidateEmailValues.email.comm_detail_id = props.comm_detail_id;
    initialCandidateEmailValues.email.references = props.references;
    initialCandidateEmailValues.email.body = props.forward
      ? props.email_body || ""
      : "";
    initialCandidateEmailValues.email.forward = props.forward;
    setCandidateEmailInitalValues(initialCandidateEmailValues);
    setPurposeList(
      getPurposeOptions(
        await reviewEmailActions.getSystemPurposeList({ only_custom: true })
      )
    );
    props.forward
      ? setSelectedToValues([
          {
            name: props?.system_notification_email,
            email: props?.system_notification_email,
          },
        ])
      : props.data?.application?.view_source_name == "Agency"
      ? agencyEmailTo(props, selectedToValues, setSelectedToValues)
      : "";
    setIsLoading(false);
  }, [props, flagForRerender]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent;
      setIsSafari(userAgent.includes("Safari") && !userAgent.includes("Chrome"));
    }
  }, []);

  if (isLoading) {
    return "";
  }

  function editSubjectHtml(subject) {
    let new_subject = subject.replace(/(<([^>]+)>)/gi, "");
    new_subject = new_subject
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&gt;/g, ">")
      .replace(/&lt;/g, "<")
      .replace(/&rsquo;/g, "’");
    new_subject = new_subject.replace(/\n/g, " ");
    return new_subject.trim();
  }

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={async () => {
              if (props.isActiveEmail) {
                props.setEmailModal(false);
                await markActiveUnsuccessful(props);
              } else {
                props.setEmailModal(false);
              }
            }}
          >
            <Close/>
            CLOSE
          </div>
          <div className={FormModalStyle.Modal__Container__ContentSection}>
            <h1
              className={
                FormModalStyle.Modal__Container__ContentSection__Heading
              }
            >
              {props.replyTo || props.messageId
                ? TEXTS["reply_email"]["heading"]
                : TEXTS[props.email_type]["heading"]}
            </h1>
            <Formik
              initialValues={initialCandidateEmailValues}
              validationSchema={CANDIDATE_EMAIL_VALIDATION}
              innerRef={formRef}
              onSubmit={(values, event) => {
                values.email.subject = editSubjectHtml(values.email.subject);
                if (props.email_type == "send_email") {
                  submitKanbanEmail({
                    values: values,
                    router: router,
                    setEmailModal: props.setEmailModal,
                    selectedValues: selectedValues,
                    selectedCards: props.selectedCards,
                    setSelectedCards: props.setSelectedCards,
                    setActionBar: props.setActionBar,
                    status: props.status,
                    moving_status: props.moving_status,
                    isActiveEmail: props.isActiveEmail,
                    setJobData: props.setJobData,
                    activeTab: props.activeTab,
                    filterData: props.filterData,
                    job_id: props.job_id,
                    from: props.from,
                    setInitialData: props.setInitialData,
                    setShowLoader: setShowLoader,
                  });
                } else {
                  submitCandidateEmail(
                    values,
                    router,
                    props.setEmailModal,
                    props.setFlagForRerender,
                    props.initialData,
                    props.setInitialData,
                    selectedValues,
                    selectedToValues,
                    setShowLoader,
                    props.entity_id,
                    props.entity_type,
                    formRef
                  );
                }
              }}
            >
              {(formik) => (
                <Form>
                  <div
                    className={
                      FormModalStyle.Modal__Container__ContentSection__Block
                    }
                  >
                    <div
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__TextContainer
                      }
                    >
                      <label
                        className={
                          FormModalStyle.Modal__Container__ContentSection__Block__TextContainer__Heading
                        }
                      >
                        {TEXTS.purpose}
                      </label>
                      <div
                        className={
                          FormModalStyle.Modal__Container__ContentSection__Block__TextContainer__SmallText
                        }
                      >
                        (Select from your templates)
                      </div>
                    </div>
                    <FormikControl
                      control="select"
                      type="text"
                      formik={formik}
                      errorClass={PageStyle.Form__Error}
                      className={`${PageStyle.Form__Input} thresholdmodl`}
                      name={"email.purpose"}
                      options={purposeList}
                      style={InputError(formik, "email.purpose")}
                      onChange={async (option) => {
                        await getCustomTemplate(
                          option,
                          formik,
                          setSubject,
                          setDataVariables,
                          setFlagForRerender
                        );
                      }}
                    />
                  </div>
                  <div
                    className={
                      FormModalStyle.Modal__Container__ContentSection__Block
                    }
                  >
                    <label
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      {props.replyTo || props.messageId
                        ? TEXTS.reply_to
                        : TEXTS.To}
                    </label>
                    <div
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block
                      }
                    >
                      {!props.forward &&
                        !(
                          props.data?.application?.view_source_name == "Agency"
                        ) && (
                          <div className={PageStyle.SetupPopup__ToChips}>
                            <div>
                              <span className={PageStyle.SetupPopup__ToName}>
                                {props.from == "kanban" ? (
                                  <>
                                    {props?.system_notification_email},{" "}
                                    {getCandidateName(props.selectedCards)}{" "}
                                  </>
                                ) : (
                                  getEmailTo(props)
                                )}

                                {props.selectedCards &&
                                props.candidate_count > 1
                                  ? ` + ${props.candidate_count - 1} More`
                                  : ""}
                              </span>
                            </div>
                          </div>
                        )}
                      {(props.forward ||
                        props.data?.application?.view_source_name ==
                          "Agency") && (
                        <>
                          <FormikControl
                            control="autosuggestInput"
                            errorClass={PageStyle.Form__Error}
                            formik={formik}
                            getSuggestionValue={
                              autosuggest_action.getSuggestionValue
                            }
                            inputProps={{
                              className: `AutosuggestOpenUp ${PageStyle.Form__Input}`,
                              formik: formik,
                              name: "email.to",
                              onChange: (value, { newValue }) => {
                                formik.touched["email.to"] = true;
                                formik.setStatus("email.to", "");
                                setToValue(newValue);
                              },
                              onKeyDown: (event) => {
                                autosuggest_action.handleKeyDown(
                                  event,
                                  selectedToValues,
                                  setSelectedToValues,
                                  setSelectedToUserCount,
                                  setToValue,
                                  formik
                                );
                              },
                              placeholder: "Start typing name",
                              style: InputError(formik, `email.to`),
                              value: toValue,
                            }}
                            onSuggestionsClearRequested={
                              autosuggest_action.onSuggestionsClearRequested
                            }
                            onSuggestionsFetchRequested={
                              autosuggest_action.onSuggestionsFetchRequested
                            }
                            onSuggestionSelected={(event, { suggestion }) => {
                              if (suggestion.user_attributes.email.length > 0) {
                                setToValue("");
                                autosuggest_action.onSuggestionSelectionEmail(
                                  {
                                    email: suggestion.user_attributes.email,
                                    name_initials:
                                      suggestion.user_attributes.name_initials,
                                    name: suggestion.user_attributes.name,
                                    photo_url:
                                      suggestion.user_attributes.photo_url,
                                  },
                                  selectedToValues,
                                  setSelectedToValues,
                                  setToValue,
                                  setSelectedToUserCount,
                                  formik
                                );
                              }
                            }}
                            renderSuggestion={
                              autosuggest_action.renderSuggestion
                            }
                            renderInputComponent={(props) =>
                              autosuggest_action.renderInputComponent(
                                props,
                                selectedToValues,
                                setSelectedToValues,
                                setSelectedToUserCount,
                                setToValue
                              )
                            }
                            shouldRenderSuggestions={
                              autosuggest_action.shouldRenderSuggestions
                            }
                            suggestions={suggestion}
                            type="email"
                          />

                          {selectedToValues.map(function (element, index) {
                              return (
                                <div
                                  className={`Sharecv emailchipsspace ${PageStyle.Tagrow}`}
                                  key={index}
                                >
                                  <div className={PageStyle.Tagrow__Tags}>
                                    {element?.photo_url ? (
                                      <img
                                        src={element?.photo_url}
                                        className="JobImageSmall"
                                      />
                                    ) : (
                                      element.name_initials && (
                                        <div className={PageStyle.Tagrow__Prefix}>
                                          {element.name_initials}
                                        </div>
                                      )
                                    )}

                                    <p className={`ml6 mb0`}>
                                      {element.name || element.email}
                                    </p>
                                    <button
                                      type="button"
                                      className={PageStyle.Tagrow__Cancel}
                                      onClick={(event) =>
                                        autosuggest_action.removeSelectedValues(
                                          event,
                                          selectedToValues,
                                          setSelectedToValues,
                                          setSelectedToUserCount
                                        )
                                      }
                                      data-index={index}
                                    >
                                      {element.email !=
                                        props?.system_notification_email && (
                                        <Close/>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                        </>
                      )}
                    </div>
                  </div>
                  <div
                    className={
                      FormModalStyle.Modal__Container__ContentSection__Block
                    }
                  >
                    <label
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      {TEXTS.CC}
                    </label>
                    <FormikControl
                      control="autosuggestInput"
                      errorClass={PageStyle.Form__Error}
                      formik={formik}
                      getSuggestionValue={autosuggest_action.getSuggestionValue}
                      inputProps={{
                        className: `AutosuggestOpenUp ${PageStyle.Form__Input}`,
                        formik: formik,
                        name: "email.cc",
                        onChange: (value, { newValue }) => {
                          formik.touched["email.cc"] = true;
                          formik.setStatus("email.cc", "");
                          setValue(newValue);
                        },
                        placeholder: "Start typing name",
                        style: InputError(formik, `email.cc`),
                        value: value,
                        onKeyDown: (event) => {
                          if (["Enter"].includes(event.key))
                            event.preventDefault();
                        },
                      }}
                      onSuggestionsClearRequested={
                        autosuggest_action.onSuggestionsClearRequested
                      }
                      onSuggestionsFetchRequested={
                        autosuggest_action.onSuggestionsFetchRequested
                      }
                      onSuggestionSelected={(event, { suggestion }) => {
                        if (suggestion.user_attributes.email.length > 0) {
                          setValue("");
                          autosuggest_action.onSuggestionSelectionEmail(
                            {
                              email: suggestion.user_attributes.email,
                              name_initials:
                                suggestion.user_attributes.name_initials,
                              name: suggestion.user_attributes.name,
                              photo_url: suggestion.user_attributes.photo_url,
                            },
                            selectedValues,
                            setSelectedValues,
                            setValue,
                            setSelectedUserCount,
                            formik
                          );
                        }
                      }}
                      renderSuggestion={autosuggest_action.renderSuggestion}
                      shouldRenderSuggestions={
                        autosuggest_action.shouldRenderSuggestions
                      }
                      suggestions={suggestion}
                      type="email"
                    />
                    <div className={`Dpflexonly Flexflow`}>
                    {selectedValues.map(function (element, index) {
                      return (
                        element.email &&
                        element.email != props?.system_notification_email && (
                          <div
                            className={`Sharecv emailchipsspace ${PageStyle.Tagrow}`}
                            key={index}
                          >
                            <div className={PageStyle.Tagrow__Tags}>
                              {element?.photo_url ? (
                                <img
                                  src={element?.photo_url}
                                  className="JobImageSmall"
                                />
                              ) : (
                                element.name_initials && (
                                  <div className={PageStyle.Tagrow__Prefix}>
                                    {element.name_initials}
                                  </div>
                                )
                              )}

                              <p className={`ml6`}>
                                {element.name || element.email}
                              </p>
                              <button
                                type="button"
                                className={PageStyle.Tagrow__Cancel}
                                onClick={(event) =>
                                  autosuggest_action.removeSelectedValues(
                                    event,
                                    selectedValues,
                                    setSelectedValues,
                                    setSelectedUserCount
                                  )
                                }
                                data-index={index}
                              >
                                {element.email !=
                                  props?.system_notification_email && (
                                  <Close/>
                                )}
                              </button>
                            </div>
                          </div>
                        )
                      );
                    })}
                    </div>
                  </div>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                  >
                    <label
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      {TEXTS.Subject} *
                    </label>
                    {!isSafari && (
                      <div className="NotSupport">
                        <Exclamation /> {`Your browser doesn't support direct access to the clipboard. Please use the ⌘+X/C/V keyboard shortcuts instead.`}
                      </div>
                    )}
                    <FormikControl
                      id="email_template_subject"
                      key={flagForRerender}
                      apiKey={process.env.NEXT_PUBLIC_TINYMCE_API_KEY}
                      control="customEditor"
                      formik={formik}
                      onInit={(evt, editor) =>
                        (editorSubjectRef.current = editor)
                      }
                      textareaName={"email.subject"}
                      identifierClass="emailTemplateSubject"
                      style={InputError(formik, `email.subject`)}
                      value={formik.values.email.subject}
                      onEditorChange={(value, editor) => {
                        formik.setFieldValue("email.subject", value);
                      }}
                      init={{
                        height: 50,
                        resize: false,
                        menubar: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "image",
                          "charmap",
                          "print",
                          "preview anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "paste",
                          "help",
                          "wordcount",
                          "autoresize",
                          "noneditable",
                          "contextmenu",
                          "paste"
                        ],
                        readOnly: props?.replyTo?.length > 0,
                        toolbar: "tokens",
                        link_target_list: false,
                        contextmenu: isSafari ? "copy paste | link" : "link",
                        paste_as_text: true, 
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        newline_behavior: "block",
                        noneditable_regexp: /\{\{[^\}]+\}\}/g,
                        setup: (editor) => {
                          editor.ui.registry.addMenuButton("tokens", {
                            text: TEXTS.tag_heading,
                            tooltip: TEXTS.insert_token,
                            fetch: (callback) => {
                              var items = subject.map((subject) => {
                                return {
                                  type: "menuitem",
                                  text: subject.text,
                                  onAction: () => {
                                    editor.insertContent(subject.value);
                                  },
                                };
                              });
                              callback(items);
                            },
                          });
                          editor.on("keydown", function (e) {
                            if (e.keyCode == 13) {
                              e.preventDefault();
                            }
                          });
                        },
                        paste_preprocess: function (plugin, args) {
                          args.content = args.content.replace(
                            /(<([^>]+)>)/gi,
                            ""
                          );
                        },
                      }}
                    />
                  </div>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt10`}
                  >
                    <label
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      {TEXTS.Email_Body} *
                    </label>
                    {!isSafari && (
                      <div className="NotSupport">
                        <Exclamation /> {`Your browser doesn't support direct clipboard access. Please use the keyboard shortcuts: Ctrl+X/C/V (Windows) or ⌘+X/C/V (Mac).`}
                      </div>
                    )}
                    <FormikControl
                      id="email_template_body"
                      key={flagForRerender}
                      control="customEditor"
                      formik={formik}
                      onInit={(evt, editor) => (editorBodyRef.current = editor)}
                      textareaName={"email.body"}
                      identifierClass="emailTemplateBody"
                      style={InputError(formik, "email.body")}
                      value={formik.values.email.body}
                      onEditorChange={(value) => {
                        formik.setFieldValue("email.body", value);
                      }}
                      init={{
                        height: 500,
                        menubar: false,
                        resize: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "image",
                          "charmap",
                          "preview",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "code",
                          "fullscreen",
                          "insertdatetime",
                          "media",
                          "table",
                          "help",
                          "wordcount",
                          "noneditable",
                          'contextmenu', 
                          'paste'
                        ],
                        toolbar:
                          "undo redo | blocks | " +
                          "bold italic backcolor | link | alignleft aligncenter " +
                          "alignright alignjustify | tokens",
                          link_target_list: false,
                          contextmenu: isSafari ? "copy paste | link" : "link",
                          paste_as_text: true, 
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        noneditable_regexp: /\{\{[^\}]+\}\}/g,
                        allow_html_in_named_anchor: true,
                        setup: (editor) => {
                          editor.ui.registry.addMenuButton("tokens", {
                            text: TEXTS.tag_heading,
                            tooltip: TEXTS.insert_token,
                            fetch: (callback) => {
                              var items = dataVariables.map((dataVariable) => {
                                return {
                                  type: "menuitem",
                                  text: dataVariable.text,
                                  onAction: () => {
                                    editor.insertContent(dataVariable.value);
                                  },
                                };
                              });
                              callback(items);
                            },
                          });
                        },
                      }}
                    />
                    {
                      <input
                        type="hidden"
                        value={props.messageId}
                        name="email.reply_to"
                        id="reply_to"
                      />
                    }
                    {props.forward && (
                      <input
                        type="hidden"
                        value={props.forward}
                        name="email.forward"
                        id="forward"
                      />
                    )}
                    <input
                      type="hidden"
                      value={props.references}
                      name="email.references"
                      id="references"
                    />
                    <input
                      type="hidden"
                      value={props.forward}
                      name="email.forward"
                      id="forward"
                    />
                    <input
                      type="hidden"
                      value={props.references}
                      name="email.references"
                      id="references"
                    />
                    <input type="hidden" name="email.entity_type" />
                  </div>
                  <div
                    className={
                      FormModalStyle.Modal__Container__ContentSection__Block
                    }
                  >
                    <label
                      htmlFor="attachments"
                      className={
                        FormModalStyle.Modal__Container__ContentSection__Block__Heading
                      }
                    >
                      {TEXTS.Attachment}
                    </label>
                    <div className={`Dpflex addDoc`}>
                      <Button
                        onClick={() => {
                          document.getElementById("attachments").click();
                        }}
                        buttonstyle={PageStyle.primarybtn}
                      >
                        {TEXTS.ADD_DOCUMENT}
                      </Button>
                      <input
                        id="attachments"
                        className={`${PageStyle.SetupPopup__AddFile}`}
                        name="email.attachments"
                        type="file"
                        multiple
                        onChange={(event) => {
                          var new_files = Array.from(event.currentTarget.files);
                          var attachment_list =
                            attachmentList.concat(new_files);
                          setAttachmentList(attachment_list);
                          formik.setFieldValue(
                            "email.attachments",
                            attachment_list
                          );
                        }}
                      ></input>
                      <div
                        className={PageStyle.SetupPopup__AttachmentContainer}
                      >
                        {attachmentList.map((file, index) => {
                          return (
                            <div
                              className={`AttachmentChip ${PageStyle.SetupPopup__Status}`}
                              data-index={index}
                              key={`attachments_${index}`}
                            >
                              <span className={PageStyle.SetupPopup__Name}>
                                {file.name}
                              </span>
                              <div
                                className={
                                  PageStyle.FileDisplayContainer__Close
                                }
                              >
                                <Image
                                  src="/icons/close.png"
                                  height={13}
                                  width={13}
                                  alt=""
                                  onClick={(event) => {
                                    removeAttachment(
                                      event,
                                      attachmentList,
                                      setAttachmentList,
                                      setFlagForRerender
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection}
                  >
                    <Button buttonstyle={PageStyle.primarybtn} type="submit">
                      {TEXTS.Save}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
      {showLoader && <Loading />}
    </div>
  );
}
